import React from "react";
import { Field } from "formik";
import Input from "../../../ui/Input";
import { DropDown } from "../../../ui/DropDown";
import styled from "styled-components";
import { TitleText } from "../../../ui/Text";

export const KPIGlobalSettings = () => {
  return (
    <Container>
      <Field
        name="respondents"
        component={Input}
        label="Number of respondents"
      />
      <Field
        name="review_cycle"
        component={DropDown}
        options={[
          { label: "daily", value: "daily" },
          { label: "weekly", value: "weekly" },
          { label: "monthly", value: "monthly" },
          { label: "quarterly", value: "quarterly" },
          { label: "half-yearly", value: "half-yearly" },
          { label: "yearly", value: "yearly" },
        ]}
        isBordered={true}
        width="97%"
        dropdownLabel="Review cycle"
      />
      <ReviewSection>
        <Field
          name="review_start_days"
          component={Input}
          label="Review starts"
          width="75%"
        />
        <TitleText>days before end of period.</TitleText>
      </ReviewSection>
    </Container>
  );
};

const Container = styled.div`
  display: grid;
  grid-template-rows: 5em 5em 5em;
  grid-row-gap: 1em;
`;
const ReviewSection = styled.div`
  display: flex;
  align-items: center;
`;
